angular
    .module("accordionProrogaMoratoria.components", [])
    .component("accordionProrogaMoratoria", {
        templateUrl: "ng/components/accordionProrogaMoratoria/accordionProrogaMoratoria.view.html",
        bindings: {
            validateComponent:'&',
            userNdg:'='

        },
        controllerAs: "accordionProrogaMoratoriaCtrl",
        controller: AccordionProrogaMoratoria
    })

    function AccordionProrogaMoratoria(
        $modalService,
        $arcService,
        $location
    ){
        var self = this;

        self.$onInit = function(){
            popolateTableMoratoria();
            controlCheck();
        }

        self.check= function(el){
           el.selected = !el.selected;
           controlCheck();
       }

       var controlCheck = function(){
          var test= self.listOfContract && 
          self.listOfContract.some(function(element){
               return element.selected == true;
            })
        
            if(test){
                self.enableButton=true;
            }else{
                self.enableButton= false;
            }
       }

       self.modalClose = function(){

           $modalService.closeModal("confirmSelected");
           self.restCalled= false;
       }


        self.submitMoratoria = function(value){
           self.restCalled= true;
           if(!value){
               $modalService.openModal("confirmSelected");

           }else{
               $modalService.closeModal("confirmSelected");
               $arcService.submitMoratoria(self.popolateListOfContract(), self.userNdg )
                .then(function(response){
                    if(response.success){
                        $location.path("/");
                    }
                        self.restCalled= false;

                })
                .catch(function(error){
                    console.log(error);
                    self.restCalled= false;

                })

           }     
       }

        self.popolateListOfContract = function(){
           return self.listOfContract && self.listOfContract.filter(function(e){
                        return e.selected ==true;
                    }).map(function(el){
                        return {numeroContratto: el.numeroContratto,
                                tipoMoratoria: el.tipoMoratoria,
                                numeroModulo: el.numeroModulo
                        }
                    })

       }

       var popolateTableMoratoria = function(){
           self.isPending = true;
           $arcService.getContrattiMoratoria(self.userNdg)
                .then(function(response){
                    self.listOfContract = response.listContratti;   
                    self.label= response.label;
                    self.disabled = response.disabled
                    self.isPending = false;      
                })
                .catch(function(error){
                   console.log(error);
                })
       }

       self.selectAll = function(){

           self.listOfContract.forEach(function(element){
               if(!element.moratoriaRequested){
                   element.selected= true;
               }
           })

           controlCheck();
       }


    }